import currencies from "../configs/currencies.json";
const getSymbolFromCurrency = (currency: string) => {
  return currencies?.find(
    (c: { value: string; name: string; displayName: string }) => {
      return c.value === currency;
    }
  )?.name;
};
export default getSymbolFromCurrency;
